<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00007">CONTENTS.</h2>
<div class="center">
<table border="0" cellpadding="14" cellspacing="0" class="calibre7" summary="">
<tbody class="calibre8"><tr class="calibre9"> <td class="calibre22"><span class="smcap">chapter</span>.</td>
<td class="calibre10"></td>
<td class="calibre22"><span class="smcap">page</span>.</td>
</tr>
<tr class="calibre9"> <td class="calibre22">I.</td>
<td class="calibre10">“<span class="smcap">Railroad Blake</span>”</td>
<td class="calibre22"><a class="reference" href="#/Text/Section0005">1</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22">II.</td>
<td class="calibre10"><span class="smcap">A Race for the Railroad Cup</span></td>
<td class="calibre22"><a class="reference" href="#/Text/Section0006#CHAPTER_II">8</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22">III.</td>
<td class="calibre10"><span class="smcap">A Cruel Accusation</span></td>
<td class="calibre22"><a class="reference" href="#/Text/Section0007#CHAPTER_III">16</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22">IV.</td>
<td class="calibre10"><span class="smcap">Starting into the World</span></td>
<td class="calibre22"><a class="reference" href="#/Text/Section0008#CHAPTER_IV">22</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22">V.</td>
<td class="calibre10"><span class="smcap">Choosing a Career</span></td>
<td class="calibre22"><a class="reference" href="#/Text/Section0009#CHAPTER_V">27</a></td>
</tr>
<tr class="calibre9"> <td class="calibre22">VI.</td>
<td class="calibre10"><span class="smcap">Smiler, the Railroad Dog</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0010#CHAPTER_VI" title="Link target outside of Sample">34</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">VII.</td>
<td class="calibre10"><span class="smcap">Rod, Smiler, and the Tramp</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0011#CHAPTER_VII" title="Link target outside of Sample">40</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">VIII.</td>
<td class="calibre10"><span class="smcap">Earning a Breakfast</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0012#CHAPTER_VIII" title="Link target outside of Sample">52</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">IX.</td>
<td class="calibre10"><span class="smcap">Gaining a Foothold</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0013#CHAPTER_IX" title="Link target outside of Sample">59</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">X.</td>
<td class="calibre10"><span class="smcap">A Thrilling Experience</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0014#CHAPTER_X" title="Link target outside of Sample">66</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XI.</td>
<td class="calibre10"><span class="smcap">A Battle with Tramps</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0015#CHAPTER_XI" title="Link target outside of Sample">71</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XII.</td>
<td class="calibre10"><span class="smcap">Bound, Gagged, and a Prisoner</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0016#CHAPTER_XII" title="Link target outside of Sample">79</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XIII.</td>
<td class="calibre10"><span class="smcap">How Brakeman Joe was Saved</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0017#CHAPTER_XIII" title="Link target outside of Sample">86</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XIV.</td>
<td class="calibre10"><span class="smcap">The Superintendent Investigates</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0018#CHAPTER_XIV" title="Link target outside of Sample">92</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XV.</td>
<td class="calibre10"><span class="smcap">Smiler to the Rescue</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0019#CHAPTER_XV" title="Link target outside of Sample">99</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XVI.</td>
<td class="calibre10"><span class="smcap">Snyder Appleby’s Jealousy</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0020#CHAPTER_XVI" title="Link target outside of Sample">106</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XVII.</td>
<td class="calibre10"><span class="smcap">Rod as a Brakeman</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0021#CHAPTER_XVII" title="Link target outside of Sample">115</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XVIII.</td>
<td class="calibre10"><span class="smcap">Working for a Promotion</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0022#CHAPTER_XVIII" title="Link target outside of Sample">121</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XIX.</td>
<td class="calibre10"><span class="smcap">The Express Special</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0023#CHAPTER_XIX" title="Link target outside of Sample">126</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XX.</td>
<td class="calibre10"><span class="smcap">Trouble in the Money Car</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0024#CHAPTER_XX" title="Link target outside of Sample">135</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXI.</td>
<td class="calibre10"><span class="smcap">Over the Top of the Train</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0025#CHAPTER_XXI" title="Link target outside of Sample">142</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXII.</td>
<td class="calibre10"><span class="smcap">Stop Thief!</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0026#CHAPTER_XXII" title="Link target outside of Sample">148</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXIII.</td>
<td class="calibre10"><span class="smcap">A Race of Locomotives</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0027#CHAPTER_XXIII" title="Link target outside of Sample">155</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXIV.</td>
<td class="calibre10"><span class="smcap">Arrested on Suspicion</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0028#CHAPTER_XXIV" title="Link target outside of Sample">161</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXV.</td>
<td class="calibre10"><span class="smcap">The Train Robber Learns of Rod’s Arrest</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0029#CHAPTER_XXV" title="Link target outside of Sample">168</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXVI.</td>
<td class="calibre10"><span class="smcap">A Welcome Visitor</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0030#CHAPTER_XXVI" title="Link target outside of Sample">174</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXVII.</td>
<td class="calibre10"><span class="smcap">The Sheriff is Interviewed</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0031#CHAPTER_XXVII" title="Link target outside of Sample">180</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXVIII.</td>
<td class="calibre10"><span class="smcap">Light Dawns upon the Situation</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0032#CHAPTER_XXVIII" title="Link target outside of Sample">186</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXIX.</td>
<td class="calibre10"><span class="smcap">An Arrival of Friends and Enemies</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0033#CHAPTER_XXIX" title="Link target outside of Sample">192</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXX.</td>
<td class="calibre10"><span class="smcap">Where are the Diamonds?</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0034#CHAPTER_XXX" title="Link target outside of Sample">198</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXI.</td>
<td class="calibre10"><span class="smcap">One Hundred Miles an Hour!</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0035#CHAPTER_XXXI" title="Link target outside of Sample">205</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXII.</td>
<td class="calibre10"><span class="smcap">Snatching Victory from Defeat</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0036#CHAPTER_XXXII" title="Link target outside of Sample">211</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXIII.</td>
<td class="calibre10"><span class="smcap">A Wrecking Train</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0037#CHAPTER_XXXIII" title="Link target outside of Sample">217</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXIV.</td>
<td class="calibre10"><span class="smcap">Rod Accepts the Legacy</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0038#CHAPTER_XXXIV" title="Link target outside of Sample">223</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXV.</td>
<td class="calibre10"><span class="smcap">Firing on Number 10</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0039#CHAPTER_XXXV" title="Link target outside of Sample">231</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXVI.</td>
<td class="calibre10"><span class="smcap">The Only Chance of Saving the Special</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0040#CHAPTER_XXXVI" title="Link target outside of Sample">237</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXVII.</td>
<td class="calibre10"><span class="smcap">Independence or Pride</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0041#CHAPTER_XXXVII" title="Link target outside of Sample">245</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXVIII.</td>
<td class="calibre10"><span class="smcap">A Moral Victory</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0042#CHAPTER_XXXVIII" title="Link target outside of Sample">252</span></td>
</tr>
<tr class="calibre9"> <td class="calibre22">XXXIX.</td>
<td class="calibre10"><span class="smcap">Snyder is Forgiven</span></td>
<td class="calibre22"><span class="reference" href="#/Text/Section0043#CHAPTER_XXXIX" title="Link target outside of Sample">258</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?0d7a1162